import './App.css';
import Allroutes from './routes';
import { HelmetProvider } from "react-helmet-async";
import "aos/dist/aos.css";
function App() {
  return (

    <HelmetProvider>
    <Allroutes />
    </HelmetProvider>
  );
}

export default App;
